// extracted by mini-css-extract-plugin
module.exports = {"container":"EVsListComponent_container__wMn6W","title":"EVsListComponent_title__6_MN7","count":"EVsListComponent_count__Hdazh","evsList":"EVsListComponent_evsList__CS3nr"};